// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const ReimbursementSummaryDetailsData = t.struct({
    detail: t.struct({
        data: t.Object,
        display: t.list(t.String)
    }),
    rowData: t.list(t.Object)
}, 'ReimbursementSummaryDetailsData');

export const getDefaultState = () =>
    new ReimbursementSummaryDetailsData({
        detail: {
            data: {},
            display: []
        },
        rowData: []
    });

export default ReimbursementSummaryDetailsData;




// WEBPACK FOOTER //
// ./src/reimbursement-summary/details/state/data.js